import React, { Component } from 'react';
import { BrowserRouter } from "react-router-dom";

import App from 'shared/App';

import store from 'redux/store';
import { Provider } from 'react-redux';


export default class extends Component {

    // shouldComponentUpdate(nextProps, nextState) {
    //     return false;
    // }

    render() {
        return (
            <BrowserRouter>
                <Provider store={store}>
                    <App/>
                </Provider>
            </BrowserRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/Root.js